import {AbstractFileUploadController} from "./AbstractFileUploadController";
import {IFileUploadController} from "./IFileUploadController";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {Injectable} from "@angular/core";

@Injectable()
export class StandardFileUploadController extends AbstractFileUploadController implements IFileUploadController {

  constructor(controllerEventBus: ControllerEventBus) {
    super(controllerEventBus);
  }
}
